import { QueryDocumentSnapshot } from 'firebase/firestore';

import { DemmiFS } from '@subhanhabib/demmilib';

export const sortSupportChats = (chats: DemmiFS.DemmiSupportVendor[]) => {
  return chats.sort((a, b) =>
    (a.lastMessage?.timestamp ?? a.createdAt) >
    (b.lastMessage?.timestamp ?? b.createdAt)
      ? -1
      : 1,
  );
};

export const parseToDemmiSupportChat = (
  doc: QueryDocumentSnapshot<DemmiFS.FSDemmiSupportVendor>,
): DemmiFS.DemmiSupportVendor => {
  return {
    docID: doc.id,
    ...(doc.data() as DemmiFS.FSDemmiSupportVendor),
  };
};

export const parseToDemmiSupportMessage = (
  doc: QueryDocumentSnapshot<DemmiFS.FSDemmiSupportMessage>,
): DemmiFS.DemmiSupportMessage => {
  return {
    docID: doc.id,
    ...(doc.data() as DemmiFS.FSDemmiSupportMessage),
  };
};
